export default {
  infoTitle: {
    id: 'service_drawer_faq_title',
    defaultMessage: 'Frequently Asked Questions',
  },
  infoQuestion1: {
    id: 'service_drawer_faq_question1',
    defaultMessage: 'How is this different from my Back Market warranty?',
  },
  infoResponse1: {
    id: 'service_drawer_faq_response1',
    defaultMessage:
      "Back Market’s commercial warranty is included free with every purchase and covers manufacturing defects — things that were wrong before you got the device. Repair & Replace goes further: it includes accidental damage, physical faults, and issues that develop from everyday use. Think of it as the warranty's upgrade.",
  },
  infoQuestion2: {
    id: 'service_drawer_faq_question2',
    defaultMessage:
      "What's the difference between the monthly and yearly plans?",
  },
  infoResponse2part1: {
    id: 'service_drawer_faq_response2_part1',
    defaultMessage:
      'Both plans include identical service. The difference is how you pay:',
  },
  infoResponse2Monthly: {
    id: 'service_drawer_faq_response2_monthly',
    defaultMessage:
      'Monthly: pay each month. 12-month minimum, then cancel anytime.',
  },
  infoResponse2Yearly: {
    id: 'service_drawer_faq_response2_yearly',
    defaultMessage:
      'Yearly: one upfront payment. Renews automatically each year.',
  },
  infoResponse2part2: {
    id: 'service_drawer_faq_response2_part2',
    defaultMessage:
      "The yearly plan works out cheaper over 12 months and you're not locked in. Cancel the auto-renewal anytime before it kicks in, or within 30 days of renewal if you change your mind, for a full refund.",
  },
  infoQuestion3: {
    id: 'service_drawer_faq_question3',
    defaultMessage: 'Who actually handles my repair?',
  },
  infoResponse3: {
    id: 'service_drawer_faq_response3',
    defaultMessage:
      'Repairs are carried out by Evy, our specialist device repair partner. They handle the assessment and repair process.',
  },
  infoQuestion4: {
    id: 'service_drawer_faq_question4',
    defaultMessage: 'How long will I be without my device?',
  },
  infoResponse4: {
    id: 'service_drawer_faq_response4',
    defaultMessage:
      "Once we receive your device, repairs typically take 2 working days. Factor in shipping both ways and you're usually looking at 5–7 days in total. We recommend backing up your data before sending your device.",
  },
}
